export default __webpack_public_path__ + "static/media/Boots of Necrotic Dread.1b51b097.jpg";